import { render, staticRenderFns } from "./LeaveManagementComponent.vue?vue&type=template&id=4311d5ab&scoped=true"
import script from "./LeaveManagementComponent.vue?vue&type=script&lang=js"
export * from "./LeaveManagementComponent.vue?vue&type=script&lang=js"
import style0 from "./LeaveManagementComponent.vue?vue&type=style&index=0&id=4311d5ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4311d5ab",
  null
  
)

export default component.exports